import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';

const FACTORY_ALLOWED_PATHS = [
  '/factory/login',
  '/factory/entry',
  '/factory/operator',
  '/industrial-workflows/operator',
];

export default function IndustrialCostFactoryAccessGuard() {
  const { isFactoryOperator } = useAuth();
  const location = useLocation();

  if (
    isFactoryOperator &&
    !FACTORY_ALLOWED_PATHS.some((path) => location.pathname.startsWith(path))
  ) {
    return <Navigate to="/factory/operator" replace />;
  }

  return <Outlet />;
}